var Collections = require("./src/collections");

var HeavyHandler = function () {
    var self = this;

    this.heavys = new Collections.HashMap();

    this.heavy_order = [];
};

module.exports = HeavyHandler;

HeavyHandler.prototype.scheduleHeavy = function(tag, func, obj, args, key) {
    var heavySet = null;
    if (this.heavys.contains(tag)) {
        heavySet = this.heavys.get(tag);
    } else {
        heavySet = new Collections.HashMap();
        this.heavys.put(tag, heavySet);
    }
    var existing = heavySet.get(key);
    if(existing && existing[0] !== func)
        console.error("It is possible you are making a mistake by overwriting a heavy handler for key: "+key);
    heavySet.put(key,[func, obj, args]);
};

HeavyHandler.prototype.runHeaviesOnce = function(tags) {
    var ran_some_heavy = false;
    for (var i=0; i<tags.length; i++) {
        var tag = tags[i];
        if (this.heavys.contains(tag)) {
            var heavies_for_tag = this.heavys.get(tag);
            this.heavys.remove(tag);
            heavies_for_tag.forEach(function(key, func_info){
                func_info[0].apply(func_info[1],func_info[2]);
            });
            ran_some_heavy = true;
        }
    }
    return ran_some_heavy;
};

HeavyHandler.prototype.runHeavies = function(tags) {
    //repeat until no new heavies scheduled; heavies may schedule new heavies which have to be executed too
    var ran_some_heavy = true;
    while(ran_some_heavy) {
        ran_some_heavy = this.runHeaviesOnce(tags);
    }
};

HeavyHandler.prototype.runAllHeavies = function() {
    var self = this;

    //repeat until no new heavies scheduled; heavies may schedule new heavies which have to be executed too
    var ran_some_heavy = true;
    while(ran_some_heavy) {
        // execute the tags that were not part of the heavy order next
        var tag_order = this.heavy_order.slice();
        // execute the tags according to the heavy_order first
        var tags = this.heavys.keys();
        tags.forEach(function(tag) {
            var contains = false;
            self.heavy_order.forEach(function(order_tag) {
                if(tag == order_tag) contains = true;
            });
            if(!contains) tag_order.push(tag);
        });
        ran_some_heavy = this.runHeaviesOnce(tag_order);
    }
};

HeavyHandler.prototype.setOrder = function(heavy_order) {
    this.heavy_order = heavy_order;
};
